import {Image, Product, Variant} from "../../models/product";
import {Component, h} from "preact";
import styles from './style.module.scss';
import {productService} from "../../services/product-service";
import ProductTag from "../product-tag";
import {icons} from "../icons";
import ProductImage, {ImageDisplayType, ImageResolution} from "../product-image";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {Like} from "../../models/customer";
import {customerService} from "../../services/customer-service";
import {i18nService} from "../../services/i18n-service";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {NY_CountryService} from "../../services/country-service";
import App from "../app";
import {useSingleClick} from "../event/single-event-filter";

interface Props {
  toggleLike(variant: Variant, newLikeState: boolean, dimension: string);

  product: Product;
  variant: Variant;
  resolution?: ImageResolution;
  displayType?: ImageDisplayType;
  dimension?: string;
  likes: Like[];
  scrollContainer?: string;
  forceCutout?: boolean;
  isMobile?: boolean;
}

interface State {
  isLiked: boolean;
}

const mapToProps = ({likes}) => ({likes});

export class ProductImageWithOverlay extends Component<Props, State> {

  componentDidMount(): void {
    this.updateLikeState();
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, previousContext: any): void {
    if (this.state.isLiked !== customerService.isVariantLiked(this.props.variant, this.props.likes)) {
      this.updateLikeState();
    }
  }

  private updateLikeState() {
    if (this.props.variant) {
      this.setState({isLiked: customerService.isVariantLiked(this.props.variant, this.props.likes)})
    }
  }

  private isOutfitImageFromList(image: Image) {
    return this.props.dimension == 'List' && !this.props.isMobile && image.type == 'OUTFIT_IMAGE'
  }

  render() {
    if (!(this.props.product && this.props.variant)) {
      return null;
    }
    const product = this.props.product;
    const variant = this.props.variant;

    const productImage = this.getProductImage(variant, this.props.forceCutout);

    return (
      <div class={`${styles['image-container']}`}>

        <ProductImage scrollContainer={this.props.scrollContainer} image={productImage}
                      alt={`${i18nService.translate(productService.getTranslationKey(this.props.product))} | ${this.props.variant.getColorTranslation()} | NEW YORKER`}
                      title={`${i18nService.translate(productService.getTranslationKey(this.props.product))} | ${this.props.variant.getColorTranslation()} | NEW YORKER`}
                      resolution={this.isOutfitImageFromList(productImage) && 'high' || this.props.resolution || 'mid'}
                      displayType={this.props.displayType}/>

        {variant.hasTag() && <div
          class={`${styles.tag} ${variant.sale && !variant.comingSoon ? styles.saleTag : ''}`}>
          <ProductTag variant={variant}/></div>}
        {!NY_CountryService.isRestricted(App.countryCode) && <div class={`${styles.like} ${this.state.isLiked ? styles.fill : ''}`}
             onClick={useSingleClick(this.handleToggleLike.bind(this))}>{icons.renderHeartIcon()}</div>}
      </div>
    )
  }

  async handleToggleLike(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    await this.props.toggleLike(this.props.variant, !this.state.isLiked, this.props.dimension);
    this.updateLikeState();
  }

  getProductImage(variant: Variant, forceCutout?: boolean): Image {
    if (!variant) {
      return;
    }

    const imageCutout = variant.images.find(image => image.type === 'CUTOUT');
    const image = variant.images.find(image => image.type !== 'OUTFIT_VIDEO');

    return forceCutout && imageCutout ? imageCutout : image || new Image({});
  }
}

export default connect(mapToProps, actions)(withDeviceIndicator(ProductImageWithOverlay))